import { render } from "./Examen.vue?vue&type=template&id=26614786"
import script from "./Examen.vue?vue&type=script&lang=js"
export * from "./Examen.vue?vue&type=script&lang=js"
script.render = render

export default script